import methods from '@lottery.2.0/library/methods.js'
export default methods